// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mN8G6","textarea":"styles_textarea__2PKY6"};